<template>
  <section class="chat-window">
    <div class="header">
      <h3>{{ chat?.message ? "Testing for ChatBOT" : "No Chat Selected" }}</h3>
      <button class="more-btn">⋮</button>
    </div>

    <div class="messages-area">
      <ChatBubble
        v-for="msg in messages"
        :key="msg.id"
        :message="msg"
      />
    </div>

    <div class="preview-text">
      <p>
        <a href="#">The quick brown fox jumps</a> over the lazy dog. Early in the morning,
        sunlight streamed through the window, casting gentle patterns across the floor.
        <span class="orange">Birds chirped</span> cheerfully outside,
        <a href="#">while a soft breeze rustled the leaves</a> in the garden.
        <a href="#">Everything felt</a> calm and peaceful, making it a perfect moment
        to relax and gather <a href="#">your thoughts before starting the day.</a>
      </p>
    </div>

    <MessageComposer />
  </section>
</template>

<script setup>
import ChatBubble from "./ChatBubble.vue";
import MessageComposer from "./MessageComposer.vue";

defineProps({
  chat: Object,
  messages: Array,
});
</script>

<style scoped>
.chat-window {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header {
  padding: 16px 20px;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h3 {
  margin: 0;
  font-size: 18px;
}

.more-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.messages-area {
  flex: 1;
  padding: 22px;
  overflow: auto;
  background: #fff;
}

.preview-text {
  padding: 18px 20px;
  border-top: 1px solid #eef2f7;
  color: #374151;
  line-height: 1.7;
}

.preview-text a {
  color: #2563eb;
  text-decoration: underline;
}

.orange {
  color: #f97316;
  text-decoration: underline;
}
</style>

